import { HttpClient } from '@angular/common/http';
import { AppContextService } from '../../services/app-context.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Injectable, SecurityContext } from '@angular/core';
import {
	ExpiredContract,
	ExpiredContractsCount,
	ExpiredContractsCriteria,
	ExpiringContract,
	ExpiringContractsCount,
	ExpiringContractsCriteria,
	PendingConfirmingSupplier,
	PendingConfirmingSuppliersCount,
	PendingConfirmingSuppliersCriteria,
	PendingNonSEPAIBANs,
	PendingNonSEPAIBANsCount,
	PendingNonSEPAIBANsCriteria,
	RefusedConfirmingFundingRequest,
	RefusedConfirmingFundingRequestsCount,
	RefusedConfirmingFundingRequestsCriteria,
	RefusedConfirmingPaymentRequest,
	RefusedConfirmingPaymentRequestsCount,
	RefusedConfirmingPaymentRequestsCriteria,
} from './monitoring-api.models';
import { OperationResult } from '../../models/server-result/operation-result';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MonitoringApiService {
	constructor(
		private http: HttpClient,
		private appContext: AppContextService,
		private domSanitizer: DomSanitizer
	) {}

	public refusedConfirmingPaymentRequests(
		criteria: RefusedConfirmingPaymentRequestsCriteria
	): Observable<OperationResult<RefusedConfirmingPaymentRequest[]>> {
		return this.http.post<OperationResult<RefusedConfirmingPaymentRequest[]>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/refusedConfirmingPaymentRequests')!,
			criteria
		);
	}

	public refusedConfirmingFundingRequests(
		criteria: RefusedConfirmingFundingRequestsCriteria
	): Observable<OperationResult<RefusedConfirmingFundingRequest[]>> {
		return this.http.post<OperationResult<RefusedConfirmingFundingRequest[]>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/refusedConfirmingFundingRequests')!,
			criteria
		);
	}

	public pendingConfirmingSuppliers(
		criteria: PendingConfirmingSuppliersCriteria
	): Observable<OperationResult<PendingConfirmingSupplier[]>> {
		return this.http.post<OperationResult<PendingConfirmingSupplier[]>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/pendingConfirmingSuppliers')!,
			criteria
		);
	}

	public pendingNonSEPAIBANs(criteria: PendingNonSEPAIBANsCriteria): Observable<OperationResult<PendingNonSEPAIBANs[]>> {
		return this.http.post<OperationResult<PendingNonSEPAIBANs[]>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/pendingNonSEPAIBANs')!,
			criteria
		);
	}

	public expiringContracts(criteria: ExpiringContractsCriteria): Observable<OperationResult<ExpiringContract[]>> {
		return this.http.post<OperationResult<ExpiringContract[]>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/expiringContracts')!,
			criteria
		);
	}

	public expiredContracts(criteria: ExpiredContractsCriteria): Observable<OperationResult<ExpiredContract[]>> {
		return this.http.post<OperationResult<ExpiredContract[]>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/expiredContracts')!,
			criteria
		);
	}

	public refusedConfirmingPaymentRequestsCount(
		criteria: RefusedConfirmingPaymentRequestsCriteria
	): Observable<OperationResult<RefusedConfirmingPaymentRequestsCount>> {
		return this.http.post<OperationResult<RefusedConfirmingPaymentRequestsCount>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/refusedConfirmingPaymentRequestsCount')!,
			criteria
		);
	}

	public refusedConfirmingFundingRequestsCount(
		criteria: RefusedConfirmingFundingRequestsCriteria
	): Observable<OperationResult<RefusedConfirmingFundingRequestsCount>> {
		return this.http.post<OperationResult<RefusedConfirmingFundingRequestsCount>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/refusedConfirmingFundingRequestsCount')!,
			criteria
		);
	}

	public pendingConfirmingSuppliersCount(
		criteria: PendingConfirmingSuppliersCriteria
	): Observable<OperationResult<PendingConfirmingSuppliersCount>> {
		return this.http.post<OperationResult<PendingConfirmingSuppliersCount>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/pendingConfirmingSuppliersCount')!,
			criteria
		);
	}

	public pendingNonSEPAIBANsCount(criteria: PendingNonSEPAIBANsCriteria): Observable<OperationResult<PendingNonSEPAIBANsCount>> {
		return this.http.post<OperationResult<PendingNonSEPAIBANsCount>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/pendingNonSEPAIBANsCount')!,
			criteria
		);
	}

	public expiringContractsCount(criteria: ExpiringContractsCriteria): Observable<OperationResult<ExpiringContractsCount>> {
		return this.http.post<OperationResult<ExpiringContractsCount>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/expiringContractsCount')!,
			criteria
		);
	}

	public expiredContractsCount(criteria: ExpiredContractsCriteria): Observable<OperationResult<ExpiredContractsCount>> {
		return this.http.post<OperationResult<ExpiredContractsCount>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/monitoring/expiredContractsCount')!,
			criteria
		);
	}
}
